import { registerLocaleData } from '@angular/common'
import localeFr from '@angular/common/locales/fr'
import { LOCALE_ID, Provider } from '@angular/core'

export function registerLocales(): void {
  registerLocaleData(localeFr, 'fr')
}

/**
 * Provides locale configuration for the application
 * Use this in AppModule providers or in bootstrapApplication config
 * 
 * @param locale - The locale identifier (default: 'en-US')
 * @returns Provider for LOCALE_ID
 * 
 * @example
 * // In AppModule
 * providers: [provideLocale('fr')]
 * 
 * @example
 * // In main.ts
 * registerLocales()
 * bootstrapApplication(AppComponent, {
 *   providers: [provideLocale('fr')]
 * })
 */
export function provideLocale(locale: string = 'en-US'): Provider {
  return { provide: LOCALE_ID, useValue: locale }
}
